import {useEffect,useState} from 'react'
import {api} from '@/lib/api'
import {getToken} from '@/lib/auth'
// No role/local-storage claim grants panel visibility. Response belongs to the
// exact current session; stale responses and failed refreshes clear visibility.
export function useDashboardNavigation() {
 const [snapshot,setSnapshot]=useState<{token:string;sections:string[];super_admin:boolean}|null>(null)
 useEffect(()=>{
  let active=true,generation=0
  async function refresh() {
   const current=++generation,token=getToken()
   setSnapshot(previous=>previous?.token===token?previous:null)
   if(!token){setSnapshot(null);return}
   try {
    const data=await api.dashboardNavigation()
    if(active&&current===generation&&getToken()===token&&Array.isArray(data.sections))
     setSnapshot({token,sections:data.sections,super_admin:data.super_admin===true})
   }catch{if(active&&current===generation)setSnapshot(null)}
  }
  void refresh()
  const listener=()=>void refresh()
  window.addEventListener('focus',listener)
  window.addEventListener('storage',listener)
  window.addEventListener('ops-auth-change',listener)
  window.addEventListener('ops-policy-change',listener)
  const timer=window.setInterval(listener,30_000)
  return ()=>{active=false;generation++;window.clearInterval(timer);window.removeEventListener('focus',listener);window.removeEventListener('storage',listener);window.removeEventListener('ops-auth-change',listener);window.removeEventListener('ops-policy-change',listener)}
 },[])
 const current=snapshot?.token===getToken()?snapshot:null
 return {ready:!!current,super_admin:current?.super_admin===true,canSee:(section:string)=>section==='sandbox' ? !!current : current?.sections.includes(section)===true}
}
